import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { map } from 'rxjs/internal/operators/map';
import * as RolesRouteMap from 'app-models';
import { BENEFICIARY } from 'app-models';
import * as i6 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { environment } from 'environment-configurations';
import { sync_profile_code } from 'permission-library';
import * as i1 from '@angular/common/http';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'primeng/dynamicdialog';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from '@angular/router';
import * as i10 from 'app-services-library';

class APIWorkExperienceDetails {
    constructor(http) {
        this.http = http;
    }
    // syncBeneWorkExperienceAll1(visatype: string, caseType: string, caseId: number, synctype: string, superTaskId: number, subTaskId: number) {
    //   return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(
    //     map((response: ImagilityBaseResponse) => {
    //       if (response.status === 200) {
    //         return response;
    //       }
    //     })
    //   )
    // }
    syncBeneWorkExperienceAll(visatype, caseType, caseId, synctype, superTaskId, subTaskId, syncType) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/${synctype}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}&syncType=${syncType}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    syncProfileAll(caseId, type) {
        return this.http.post(`/petition/updateProfile/${caseId}/${type}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deletBeneWorkExperience(visaType, caseType, caseId, type, superTaskId, subTaskId, experienceId) {
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/EXPERIENCE/${experienceId}?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deletBeneWorkExperienceTools(superTaskId, subTaskId, toolId) {
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/workExperienceDetails/tools/${toolId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deletBeneWorkExperienceDuties(visaType, caseType, caseId, type, superTaskId, subTaskId, experienceId, dutyId) {
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/EXPERIENCE/${experienceId}/JOBDUTY/${dutyId}?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteBeneWorkExperienceDocuments(visaType, caseType, caseId, documentId) {
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/document/${documentId}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    ;
    getBeneExperienceInformation(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBenEdit) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`).pipe(map((response) => {
            return response.data;
        }));
    }
    syncBeneWorkExperience(visatype, caseType, caseId, experienceId, superTaskId, subTaskId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/EXPERIENCE/${experienceId}/sync?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    ;
    getBeneficiaryProfileInformation(visatype, beneficiaryId) {
        return this.http.get(`/${visatype}/beneficiary/${beneficiaryId}/personalDetails`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
}
APIWorkExperienceDetails.ɵfac = function APIWorkExperienceDetails_Factory(t) { return new (t || APIWorkExperienceDetails)(i0.ɵɵinject(i1.HttpClient)); };
APIWorkExperienceDetails.ɵprov = i0.ɵɵdefineInjectable({ token: APIWorkExperienceDetails, factory: APIWorkExperienceDetails.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIWorkExperienceDetails, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const DeleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
const NoteDialogConfigurations = {
    width: '40%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    data: {}
};
const ImportDialogConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" },
    header: 'Work Experience'
};
class BaseWorkExperienceDetailsLibraryService {
    // userType = '';
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, dialogService, guard, cacheCountyService, referenceLibraryService, router, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.dialogService = dialogService;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.onSaveEmitSubject = new Subject();
        this.questionnaire = false;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.disabledControls = false;
        this.showOthername = false;
        this.countryList = [];
        this.gcWorkExperienceDetailsResponseList = [];
        this.showSpecializedKnowledgeSection = false;
        this.notifyDestinationUser = BENEFICIARY;
        this.isWorkExperienceView = true;
        this.questionnaire = window.location.pathname === "/beneficiary-profile/profile" ? true : false;
    }
    loadInit() {
        if (this.inputData.visatype) {
            switch (this.inputData.visatype) {
                case 'L1B':
                    this.showSpecializedKnowledgeSection = true;
                    break;
            }
        }
        // froalaService.insertPageBreak();
        this.getBusniessType();
        this.getCountryList();
        this.experienceCols = [
            { field: 'designation', header: 'Job Title' },
            { field: 'employmentType', header: 'Job Type' },
            { field: 'startDate', header: 'Employed from' },
            { field: 'endDate', header: 'Employed till' },
            { field: 'companyName', header: 'Company Name' },
            { field: 'action', header: 'Action' },
        ];
        this.experienceSubCols = [
            { field: 'addressLine1', header: 'Address 1' },
            { field: 'addressLine2', header: 'Address 2' },
            { field: 'countryName', header: 'Country' },
            { field: 'stateProvinceName', header: 'State' },
            { field: 'city', header: 'City' },
            { field: 'zipCode', header: 'ZIP / Postal Code' },
        ];
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.getExperienceList();
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
            this.stepDetails = data;
            this.toggleControlsStatus();
        });
        // there is no save, so on landing of the page we are updating status to "INPROGRESS" if status is "NEW"
        // if (this.stepDetails && this.stepDetails.stepStatusDetails && this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
        //   this.updateStepStatus('INPROGRESS');
        // }
        if (this.inputData.visatype) {
            switch (this.inputData.visatype) {
                case 'L1B':
                    this.showSpecializedKnowledgeSection = true;
                    break;
            }
        }
    }
    afterViewInit() {
        this.workExperienceForm.form.valueChanges.pipe(takeUntil(this.observableSubscription$), map(() => this.workExperienceForm.dirty)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    // handleDataChange(value: string) {
    //   this.store.dispatch(new MarkDirtyFormAction({
    //     dirty: true
    //   }));
    // }
    updateExperience() {
        let a = window.location.href;
        if (a.toString().includes('/beneficiary-profile')) {
            window.location.href = window.location.origin + '/beneficiary-profile/profile?prop=BENE&section=3';
        }
        else {
            //  sessionStorage.setItem('listBeneficiaryId', this.beneficiaryPersonalDetails.beneficiaryId);
            let listBeneficiaryId = (sessionStorage.getItem('beneficiaryId'));
            sessionStorage.setItem('listBeneficiaryId', listBeneficiaryId);
            sessionStorage.setItem('bene-update-experience', 'true');
            sessionStorage.setItem('bene-profile-viewMode', 'false');
            let url;
            if (this.userType === RolesRouteMap.ATTORNEY) {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile/work-experience`, { listview: true }];
            }
            else {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile/work-experience`, { listview: true }];
            }
            0;
            sessionStorage.removeItem('bene-update-profile');
            this.router.navigate(url, { state: { redirectUrl: this.router.url, redirectPage: 'Back to Petition Builder' } });
        }
    }
    getBusniessType() {
        this.referenceLibraryService.getReferenceData('BUSTYP').pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.businessTypeList = data;
        });
    }
    //To fetch  list of countries
    getCountryList() {
        this.cacheCountyService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
            }
        });
    }
    onBusinessTypeChange(selectedValues) {
        let codes = [];
        if (selectedValues && selectedValues.length > 0) {
            selectedValues.forEach(el => {
                codes.push(this.businessTypeList.filter(x => x.id === el)[0].code);
            });
            if (codes.length > 0 && codes.indexOf('OTHER') >= 0) {
                this.showOthername = true;
            }
            else {
                this.showOthername = false;
            }
        }
    }
    getExperienceList() {
        this.apiService.getBeneExperienceInformation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, false).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.gcWorkExperienceDetailsResponseList = data ? data : [];
            // console.log(this.gcWorkExperienceDetailsResponseList, 'this.gcWorkExperienceDetailsResponseList@@@@@@@');
        });
    }
    syncMerge() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, 'merge').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getExperienceList();
            }
        });
    }
    syncReset() {
        this.apiService.syncBeneWorkExperienceAll(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, 'reset').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getExperienceList();
            }
        });
    }
    sycProfilePitition() {
        this.apiService.syncProfileAll(this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    onClickEditImmigation() {
        this.isWorkExperienceView = !this.isWorkExperienceView;
    }
    saveCloseEditWorkExperince() {
        this.getExperienceList();
        this.isWorkExperienceView = true;
    }
    handleExperienceSync(input) {
        this.apiService.syncBeneWorkExperience(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, input.id, this.inputData.superTaskId, this.inputData.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getExperienceList();
            }
        });
    }
    postFormSubmission() {
        // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
        //   this.updateStepStatus('INPROGRESS');
        // }
    }
    deleteExperienceList(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deletBeneWorkExperience(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getExperienceList();
                });
            }
        });
    }
    dutiesDelete(item, rowData) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deletBeneWorkExperienceDuties(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, rowData.id, item.dutyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getExperienceList();
                });
            }
        });
    }
    subDutiesDelete(input, rowData) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deletBeneWorkExperienceDuties(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EXPERIENCE, this.inputData.superTaskId, this.inputData.subTaskId, rowData.id, input.subDutyId)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getExperienceList();
                });
            }
        });
    }
    handleToolsDelete(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deletBeneWorkExperienceTools(this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getExperienceList();
                });
            }
        });
    }
    deleteDocuments(subexperiencelist, item) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                this.apiService.deleteBeneWorkExperienceDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, 'Success');
                    this.getExperienceList();
                });
            }
        });
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    handleCancel() {
        this.getExperienceList();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseWorkExperienceDetailsLibraryService.ɵfac = function BaseWorkExperienceDetailsLibraryService_Factory(t) { return new (t || BaseWorkExperienceDetailsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIWorkExperienceDetails), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DialogService), i0.ɵɵinject(i6.DirtyFormGuard), i0.ɵɵinject(i7.CacheCountryListService), i0.ɵɵinject(i8.ReferenceLibraryService), i0.ɵɵinject(i9.Router), i0.ɵɵinject(i10.AppServicesLibraryService)); };
BaseWorkExperienceDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseWorkExperienceDetailsLibraryService, factory: BaseWorkExperienceDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseWorkExperienceDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIWorkExperienceDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DialogService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i9.Router }, { type: i10.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-work-experience-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIWorkExperienceDetails, BaseWorkExperienceDetailsLibraryService, DeleteDialogConfigurations, ImportDialogConfigurations, NoteDialogConfigurations };
//# sourceMappingURL=base-work-experience-details-library.js.map
